<template>
    <tr v-if="index_item">
        <td v-for="column in columns">
            <span v-if="column.item.type == 'text'" v-html="index_item[column.item.attribute_name] || blank_value_text"></span>
            <span v-if="column.item.type == 'selection'" v-html="selection_value(column) || blank_value_text"></span>
            <span v-if="column.item.type == 'boolean'">
                <div v-if="column.show_toggle_button && is_loading">
                    <i class="circle notch loading icon"></i>
                </div>
                <div v-else-if="column.show_toggle_button && !is_loading" @click.prevent="toggle_attribute(column.item.attribute_name)">
                    <span v-if="index_item[column.item.attribute_name]">
                        <i class="check icon"></i> 是
                    </span>
                    <span v-if="!index_item[column.item.attribute_name]">
                        <i class="remove icon"></i> 否
                    </span>
                </div>
                <div v-else-if="!column.show_toggle_button">
                    <span v-if="index_item[column.item.attribute_name]">
                        <i class="check icon"></i> 是
                    </span>
                    <span v-if="!index_item[column.item.attribute_name]">
                        <i class="remove icon"></i> 否
                    </span>
                </div>
            </span>
        </td>
        <td>
            <div class="ui vertical buttons" v-if="is_loading">
                <div class="ui basic green loading button" v-if="edit_index_item_url">
                    {{ $t('ui.general.edit') }}
                </div>
                <a class="ui basic red loading button" v-if="delete_index_item_url">
                    {{ $t('ui.general.delete') }}
                </a>
            </div>
            <div class="ui vertical buttons" v-else>
                <router-link :to="convert_url_object(edit_index_item_url)" class="ui basic green button" v-if="edit_index_item_url">
                    {{ $t('ui.general.edit') }}
                </router-link>
                <a @click.prevent="delete_index_item" class="ui basic red button" v-if="delete_index_item_url">
                    {{ $t('ui.general.delete') }}
                </a>
            </div>
        </td>
    </tr>
</template>

<script>
export default {
    name: "CRUDTemplatesIndexItem",
    props: {
        // render內容
        columns: {
            type: Array,
            default: () => { return [] },
        },
        // render對象object
        index_item: Object,
        // 編輯頁連結url
        edit_index_item_url: Object,
        // 更新對象url
        update_index_item_url: Object,
        // 刪除對象url
        delete_index_item_url: Object,
        // auth
        authentication_token: String,
        // 更新對象的human name
        index_item_name: String,
        // response中代表更新對象的keyname
        api_response_corresponding_name_of_index_item: String,
        // 空白欄位預設文字
        blank_value_text: {
            type: String,
            default: () => { return "" },
        },
    },
    data() {
        return {
            is_loading: false
        }
    },
    computed: {
    },
    mounted() {
    },
    methods: {
        delete_index_item() {
            if (confirm(this.$t('ui.notifications.warning.are_you_sure_to_delete_it'))) {
                this.is_loading = true
                var url = this.convert_url_object(this.delete_index_item_url)

                axios.get(url, {headers: { Authorization: this.authentication_token }})
                    .then(response => {
                        if (response.data.status == "success") {
                            this.$parent.fetch_index_items()
                            // this.$noty.success('刪除' + this.index_item_name + '成功')
                            this.$noty.success(
                                this.$t('ui.notifications.success.delete__name', {
                                    name: this.index_item_name
                                })
                            )
                        } else {
                            console.log(response.data)
                            // this.$noty.error('刪除' + this.index_item_name + '失敗')
                            this.$noty.error(
                                this.$t('ui.notifications.error.delete__name', {
                                    name: this.index_item_name
                                })
                            )
                        }
                    })
                    .catch(error => {
                        console.log(error.response)
                        // this.$noty.error('刪除' + this.index_item_name + '失敗')
                        this.$noty.error(
                            this.$t('ui.notifications.error.delete__name', {
                                name: this.index_item_name
                            })
                        )
                    }).finally(() => {
                        this.is_loading = false
                    })
            }
        },
        toggle_attribute(attribute_name) {
            this.is_loading = true
            var url = this.convert_url_object(this.update_index_item_url)

            axios.post(url, {}[attribute_name] = !this.index_item[attribute_name], {headers: { Authorization: this.authentication_token }})
                .then(response => {
                    if (response.data.status == "success") {
                        this.index_item[attribute_name] = response.data[api_response_corresponding_name_of_index_item][attribute_name]
                        // this.$noty.success('更新' + this.index_item_name + '成功')
                        this.$noty.success(
                            this.$t('ui.notifications.success.update__name', {
                                name: this.index_item_name
                            })
                        )
                    } else {
                        // this.$noty.error('更新' + this.index_item_name + '失敗')
                        this.$noty.error(
                            this.$t('ui.notifications.error.update__name', {
                                name: this.index_item_name,
                            })
                        )
                    }
                })
                .catch(error => {
                    console.log(error.response)
                })
                .finally(() => {
                    this.is_loading = false
                })
        },
        convert_url_object(obj) {
            var params_obj = {}
            for (let param of obj.params) {
                switch (param.source) {
                    case "index_item":
                        params_obj[param.key_name] = this.index_item[param.attribute_name]
                        break
                    case "route_params":
                        params_obj[param.key_name] = this.$route.params[param.attribute_name]
                        break
                }
            }
            switch (obj.type) {
                case "vue":
                    return {
                        name: obj.url,
                        params: params_obj,
                    }
                    break
                case "http":
                    return new RestUrl(obj.url).parse(params_obj)
                    break
            }
        },
        selection_value(column) {
            var found_option = _.find(
                column.item.options,
                (o) => {
                    return o[column.item.option_attribute_name] == this.index_item[column.item.attribute_name]
                }
            )
            if (found_option) {
                return found_option[column.item.option_human_name]
            } else {
                return null
            }
        },
    },

}
</script>

<style scoped lang="scss">
</style>
